import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Bound } from "lib/@components/binding/Bound"

export function TailoredTabScheduleAudit({ children }) {
    const { tailoredItem: item } = useBoundContext()

    const audits = item.tailoredAudits?.keyBy("payload.taskId")

    const schedule = { id: item.scheduleId, title: item.scheduleTitle }
    const scheduleItem = { version: item.scheduleVersion, code: item.code }

    return (
        <Bound
            tailoredAudits={audits}
            schedule={schedule}
            scheduleItem={scheduleItem}
            tailoringReferenceId={item.tailoringReferenceId}
        >
            {children}
        </Bound>
    )
}
